import { styled, Stack, type StackProps } from '@mui/material'
import { ComponentType } from 'react'
import { type UiFramework } from '../types'

type RecurrenceSettingsSecondaryProps = StackProps & {
  uiFramework: UiFramework
}

export const RecurrenceSettingsSecondary = styled(Stack, {
  name: 'RecurrenceSettingsSecondary',
  shouldForwardProp: prop => prop !== 'uiFramework',
})<RecurrenceSettingsSecondaryProps>(({ theme: { spacing }, uiFramework }) => ({
  padding: `${spacing(1)} ${spacing(2)}`,
  gap: spacing(2),
  backgroundColor: uiFramework === 'legacy' ? '#F8F8F8' : '#F3F5F7',
})) as ComponentType<RecurrenceSettingsSecondaryProps>
